import React from "react";
import { connect } from "react-redux";
import { hideError } from "../actions/errorActions";

import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

class Error extends React.Component {
    render() {
        if (!this.props.error.showError) {
            return null
        }

        return (
            <Alert severity="error" onClose={() => { this.props.hideError() }} sx={{ whiteSpace: 'pre-line' }}>
                <AlertTitle>Error</AlertTitle>
                {this.props.error.errorMessage}
            </Alert>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        error: state.error,
    };
};

export default connect(mapStateToProps, { hideError })(Error);